// this is an autogenerated file from App/Account/Content/Calendar/New/AppointmentOverlay/Content/mutation-create-employee-professional-relationship.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Calendar_New_AppointmentOverlay_Content(
  $input: vaxiom_employee_professional_relationships_insert_input!
) {
  insert_vaxiom_employee_professional_relationships_one(object: $input) {
    id
    provider_id
  }
}

`